import $http from '$http';
import services from './services.js';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import Uploader from 'uploader';
import viewPhoto from 'src/common/js/viewPhoto';
import validate from 'validate';
import {
    MAP_LIST
} from '$http';
import {
    Message
} from 'element-ui';


let CONSTS = {
    hqLabel: "获取第三方公司信息",
    hcLabel: "自定义",
    ParentCustomerId: 33686
};

export default {
    mixins: [services],
    props: {
        isRequired: {
            default: false
        },
        isReadOnly: {
            default: false
        },
        value: {
            default: () => {
                return this.refsGetInitData();
            }
        },
        isAdd: {
            default: false
        },
    },
    data() {
        return {
            disabled: false,
            getTsInfoLoading: false,
            getAndHcLabel: CONSTS.hqLabel,
            isUploadImg: 0,
            // DataType: 0, //数据类型，0：非正式；1：正式；
            imgViewVisiable: false,
            imgViewSrc: "",
            selectDepartmentVisiable: false,
            companyInfo: this.getInitCompanyInfo(),
            valid: false,
            originalId: "",
            cityList: [],
            areaList: [],
            LeasingManagerName: '', //招商经理
            showData: {}, //查看数据赋值
        };
    },
    watch: {
        value: {
            deep: true,
            handler: function (val) {
                this.setValue();
            }
        }
    },
    methods: {
        showImgView(img) {
            viewPhoto.show({
                showImgId: "", //指定id显示图片
                thumbList: [{
                    src: img.Url,
                    id: ""
                }]
            });
        },
        delC_Drawing(list, i) {
            list.splice(i, 1);
        },
        getInitCompanyInfo() {
            return cloneDeep({
                Id: '',
                ParentCustomerId: 0,
                CustomerName: "", //公司名称
                //Address: '',
                LeasingManagerId: this.$store.state.sysSid, //招商经理
                BusEmployeeId: "", //业务经理
                BusEmployeeName: "",
                SocialCreditCode: "", //统一社会信用代码 
                Corporation: "", //公司法人 
                Company_Drawing: [], //营业执照 
                Corporation_Drawing: [], //公司法人身份
                DataType: 0,
                ProvId: null,
                CityId: null,
                AreaId: null,
            });
        },
        refsGetInitData() {
            this.companyInfo = this.getInitCompanyInfo()
        },
        refsetFileAddress() {
            this.companyInfo.ProvId = null;
            this.companyInfo.CityId = null;
            this.companyInfo.AreaId = null;
        },
        // 选择省
        selfChangeProvince(provincesId) {
            if (provincesId !== null) {
                this.getCity(provincesId)
            }

        },
        // 选择市
        selfChangeCity(CityId) {

            if (CityId !== null) {
                this.getArea(CityId)
            }

        },
        getTsInfo(callBack) {
            if (this.getAndHcLabel == CONSTS.hcLabel) {
                // 自定义
                this.companyInfo.ParentCustomerId = 0;
                this.resetFields();
                this.companyInfo.Id = this.originalId;
                return;
            }

            Message({
                message: '正在获取数据，请稍后...',
                duration: 0
            });
            this.getTsInfoLoading = true;

            this.$nextTick(() => {
                let Params = {
                    Sid: this.$store.state.sysSid,
                    Session: this.$store.state.sysSession,
                    Id: CONSTS.ParentCustomerId
                };
                $http.get('api/Agent/GetNewAgentByCustomerId', Params).then(res => {
                    let {
                        Data
                    } = res.data;
                    Message.closeAll();
                    this.getTsInfoLoading = false;
                    util.doResult(this, res, () => {
                        this.getAndSetData(Data, () => {
                            this.companyInfo.ParentCustomerId = CONSTS.ParentCustomerId;
                            this.getAndHcLabel = CONSTS.hcLabel;
                            this.companyInfo.CustomerName = Data.Customer //公司名称字段不一处理
                            this.companyInfo.ProvId = Data.Provinces_Id
                            this.companyInfo.CityId = Data.City_Id
                            this.companyInfo.AreaId = Data.Area_Id
                            if (this.value) {
                                this.companyInfo.Id = this.value.Id;
                            } else {
                                this.companyInfo.Id = "";
                            }
                            if (typeof callBack == "function") {
                                callBack();
                            }
                            this.disabled = true;
                        });
                        if (this.isReadOnly) {
                            this.disabled = false;
                        }
                    });
                });

            });
        },
        selectStaffFn(obj) {
            this.$emit('showSelectStaffDialog', obj); // 向上派发 toggle事件
        },
        // 获取所属业务经理
        setStaffInfo(info) {
            this.companyInfo.BusEmployeeId = info.ID;
            this.companyInfo.BusEmployeeName = info.name;
        },
        // 获取招商经理信息
        setStaffInfo2(info) {
            this.companyInfo.LeasingManagerId = info.ID;
            this.LeasingManagerName = info.name;
        },
        // 赋值
        setValue() {
            if (!isCorrectVal(this.value)) return;
            this.getAndSetData(this.value, () => {
                this.showData = this.value
                this.originalId = this.companyInfo.Id;
                if (this.companyInfo.ParentCustomerId == CONSTS.ParentCustomerId) {
                    let BusEmployeeId = this.companyInfo.BusEmployeeId;
                    let BusEmployeeName = this.companyInfo.BusEmployeeName;
                    let DataType = this.companyInfo.DataType;
                    this.getAndHcLabel = CONSTS.hqLabel;
                    this.getTsInfo(() => {
                        this.companyInfo.BusEmployeeId = BusEmployeeId;
                        this.companyInfo.BusEmployeeName = BusEmployeeName;
                        this.companyInfo.DataType = DataType;
                    });
                }
            });

        },
        getAndSetData(Data, callback) {
            let value = cloneDeep(Data);
            this.$nextTick(() => {
                this.companyInfo = cloneDeep($.extend({}, this.getInitCompanyInfo(), util.filterAndSetData(this.getInitCompanyInfo(), value)));
                //this.DataType = value.DataType;
                if (this.companyInfo.ParentCustomerId == CONSTS.ParentCustomerId) {

                    this.disabled = true;
                }
                if (this.companyInfo.ParentCustomerId == 0) {
                    this.disabled = false

                }
                if (this.companyInfo.LeasingManagerId == 0 || this.value.LeasingManagerName == undefined) {
                    this.companyInfo.LeasingManagerId = this.$store.state.sysSid
                    this.LeasingManagerName = this.LeasingManagerName
                } else if (this.value !== null) {

                    this.LeasingManagerName = this.value.LeasingManagerName
                }

                if (typeof callback == "function") {
                    callback();
                }
            });
        },
        setFiledDisabled(result) {
            return result;
        },
        validate() {
            let checkRules = [{
                name: "公司",
                value: this.companyInfo.CustomerName,
                required: this.isRequired
            }, {
                name: "所属招商经理",
                value: this.LeasingManagerName,
                required: true
            }, {
                name: "所属业务经理",
                value: this.companyInfo.BusEmployeeName,
                required: true
            }, {
                name: "统一社会信用代码",
                value: this.companyInfo.SocialCreditCode,
                required: this.isRequired
            }, {
                name: "公司法定代表人",
                value: this.companyInfo.Corporation,
                required: this.isRequired
            }, {
                name: "法人身份证",
                value: this.companyInfo.Corporation_Drawing,
                required: this.isRequired,
                msg: "请上传法人身份证图片"
            }, {
                name: "营业执照",
                value: this.companyInfo.Company_Drawing,
                required: this.isRequired,
                msg: "请上传营业执照图片"
            }, {
                name: "公司地址",
                value: this.companyInfo.ProvId,
                required: true
            }];


            var flag = util.checkForm({
                ele: this,
                rules: checkRules
            });

            if (!flag) {
                return false;
            } else {
                return this.companyInfo
            }
        },
        resetFields() {
            this.$refs.form.resetFields();
            this.companyInfo = this.getInitCompanyInfo();
            var user = JSON.parse(sessionStorage.getItem("user"));
            this.companyInfo.DataType = user.DataType
            this.getAndHcLabel = CONSTS.hqLabel;
            this.disabled = false;
            var user = JSON.parse(sessionStorage.getItem("user"));
            this.LeasingManagerName = user.RealName
        },
        companyblur() {
            $(document).unbind();
        },
        companyFocus(value) {
            $(document).unbind().keypress((e) => {
                if (e.keyCode == 32) {
                    return false;
                }
            });
        }
    },
    computed: {
        cdContainerId() {
            return 'cd_container_id-' + new Date().getTime();
        },
        cdBtnId() {
            return 'cd_btn_id-' + new Date().getTime();
        },
        crpdContainerId() {
            return 'crpd_container_id-' + new Date().getTime();
        },
        crpdBtnId() {
            return 'crpd_btn_id-' + new Date().getTime();
        },
        showImgOpt() {
            if (!this.isReadOnly && !this.disabled) {
                return true;
            }
            return false;
        },
        provinceList() {
            return this.$store.state.allProvince
        },
    },
    mounted() {
        var user = JSON.parse(sessionStorage.getItem("user"));
        this.LeasingManagerName = user.RealName
        this.setValue();
        this.companyInfo.DataType = user.DataType
        this.$nextTick(() => {

            util.initUploader(this, this.cdContainerId, this.cdBtnId, (file) => {
                this.companyInfo.Company_Drawing.push(file);
            });

            util.initUploader(this, this.crpdContainerId, this.crpdBtnId, (file) => {
                this.companyInfo.Corporation_Drawing.push(file);
            });
        });
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/components/agent-base-infonew/vm.js